import React from "react";
import moment from "moment";
import ReactMarkdown from "react-markdown";

export interface ScheduleWidgetRowProps {
  title: string;
  timeStart: Date;
  timeEnd: Date;
  titleClassName?: string;
  timeClassname?: string;
}

const ScheduleWidgetRow = ({
  title,
  timeStart,
  timeEnd,
  titleClassName,
  timeClassname,
}: ScheduleWidgetRowProps) => {
  return (
    <>
      <div className={`text-xs leading-tight ${timeClassname}`}>
        {`${moment(timeStart).format("H:mm")} - ${moment(timeEnd).format(
          "H:mm"
        )}`}{" "}
        <span className="text-gray-300">
          | {moment(timeStart).format("DD MMM YYYY")}
        </span>
      </div>
      <div className={`text-4xl font-bold ${titleClassName}`}>
        <ReactMarkdown source={title.replace(/\\n/g, "\n")} />
      </div>
    </>
  );
};

export default ScheduleWidgetRow;
